'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isValidating = exports.isValid = exports.getError = exports.getValue = undefined;
var _constants = require('../constants');

// Field value
var getValue = exports.getValue = function getValue(state, formId, name) {
  if (state[_constants.NAME][formId]) {
    return state[_constants.NAME][formId].values[name];
  }
  return undefined;
};

// Field error
var getError = exports.getError = function getError(state, formId, name) {
  if (state[_constants.NAME][formId]) {
    return state[_constants.NAME][formId].errors[name];
  }
  return undefined;
};

// Field is valid
var isValid = exports.isValid = function isValid(state, formId, name) {
  if (state[_constants.NAME][formId]) {
    return state[_constants.NAME][formId].errors[name] === '';
  }
  return false;
};

// Individual field is validating (async)
var isValidating = exports.isValidating = function isValidating(state, formId, name) {
  if (state[_constants.NAME][formId]) {
    return !!~state[_constants.NAME][formId].fieldsValidating.indexOf(name);
  }
  return false;
};